<div class="row">
    <div class="col-lg-12">
                <div class="tit-stroke" data-aos="zoom-in-down" data-aos-duration="1500">
                 <h1 class="vlt-stroke-text light preline_title">{{ParallaxQuienesSomos_props.title}}</h1>
                  <div>
                     <div class="vlt-stroke-num">{{ParallaxQuienesSomos_props.titleNum}}</div>
                   </div>
                </div>
  </div>
</div>